import { isNullOrUndefined } from 'util';
/**
 * Sanitizes and returns the given string.
 * @param inputString Unsanitized string.
 */
export function sanitize(inputString) {
    if (isNullOrUndefined(inputString))
        return inputString;
    else
        return inputString.trim();
}
